
import ChartSquareSvg from "../../assets/icon/svgJsx/ChartSquareSvg";
import RowVerticalSvg from "../../assets/icon/svgJsx/RowVerticalSvg";
import MapSvg from "../../assets/icon/svgJsx/MapSvg";
import NotificationSvg from "../../assets/icon/svgJsx/NotificationSvg";
import MessageTextSvg from "../../assets/icon/svgJsx/MessageTextSvg";
import ProfileSvg from "../../assets/icon/svgJsx/ProfileSvg";
import SettingSvg from "../../assets/icon/svgJsx/SettingSvg";
import StrongBoxSvg from "../../assets/icon/svgJsx/StrongBoxSvg";
import CoinSvg from "../../assets/icon/svgJsx/CoinSvg";
import SetupSvg from "../../assets/icon/svgJsx/SetupSvg";

const navigationConfig = [
  {
    mainMenu: {
      id: "chart",
      title: "Chart",
      icon: ChartSquareSvg,
      href: "/fullchart",
    },
  },
  {
    mainMenu: {
      id: "coinList",
      title: "Coin list",
      icon: CoinSvg,
      href: "/coinList",
    },
  },
  {
    mainMenu: { id: "heatMap", title: "HeatMap", icon:MapSvg },
    subMenus: [
      {
        id: "analysis",
        title: "Analysis",
        icon: MessageTextSvg,
        href: "/",
      },
      {
        id: "analysisList",
        title: "Analysis List",
        icon: RowVerticalSvg,
        href: "/analysisList",
      },
      {
        id: "heatMapList",
        title: "HeatMap List",
        icon:MapSvg,
        href: "/heatMap-list",
      },
      {
        id: "notification",
        title: "Notification",
        icon: NotificationSvg,
        href: "/notification",
      },
      {
        id: "userList",
        title: "User List",
        icon: ProfileSvg,
        href: "/userList",
      },
    ],
  },
  {
    mainMenu: { id: "setupList", title: "Setup List", icon: SetupSvg},
    subMenus: [
      {
        id: "setupList",
        title: "Setup list",
        icon: RowVerticalSvg,
        href: "/setupList",
      },
    ],
  },
  {
    mainMenu: { id: "tools", title: "Tools", icon: SettingSvg },
    subMenus: [
      {
        id: "imbalances",
        title: "Imbalances",
        icon: ChartSquareSvg,
        href: "/imbalances",
      },
      { id: "vmc", title: "VM/C", icon: StrongBoxSvg, href: "/vmc" },
    ],
  },
  {
    mainMenu: { id: "settings", title: "Settings", icon: SettingSvg },
    subMenus: [
      {
        id: "newPair",
        title: "New Pair",
        icon: StrongBoxSvg,
        href: "/newPair",
      },
      { id: "roles", title: "Roles", icon: ProfileSvg, href: "/roles" },
    ],
  },
];

export default navigationConfig;
